/**
 * HACKMOTION SESSION Reducers
 */
import {
    HACKMOTIONREPORT_ACTION,
    ALL_HACKMOTIONREPORT,
    ADD_HACKMOTIONREPORT,
    DELETE_HACKMOTIONREPORT,
    EDIT_HACKMOTIONREPORT
} from 'Actions/types';


const INIT_STATE = {
    hackmotionreportlist: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case HACKMOTIONREPORT_ACTION:
            return { ...state, loading: true };

        case ALL_HACKMOTIONREPORT:
            return { ...state, loading: false, hackmotionreportlist: action.payload };

        case EDIT_HACKMOTIONREPORT:
            return { ...state, loading: false, hackmotionreportlist: action.payload };

        case ADD_HACKMOTIONREPORT:
            return { ...state, loading: false };

        case DELETE_HACKMOTIONREPORT:
            return { ...state, loading: false };

        default: return { ...state };

    }
}
